import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconLightMode = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M31.535 1.922a2.1 2.1 0 0 0-1.337 1.086c-.148.285-.15.316-.168 2.677l-.018 2.39.152.333c.216.472.503.772.954.997.334.167.462.195.882.195s.549-.028.882-.195c.42-.21.697-.482.926-.91.142-.268.144-.3.144-2.735 0-2.457 0-2.465-.15-2.752-.209-.404-.615-.801-.977-.957s-.95-.215-1.29-.13m-19.951 8.25c-1.136.347-1.75 1.562-1.342 2.66.131.355.268.51 1.782 2.024 1.497 1.497 1.672 1.652 2.01 1.776.767.282 1.559.11 2.133-.465a1.97 1.97 0 0 0 .465-2.133c-.124-.338-.28-.513-1.776-2.01-1.497-1.497-1.672-1.652-2.01-1.776-.377-.138-.946-.172-1.262-.076m39.552.075c-.31.12-.552.337-1.992 1.777-1.497 1.497-1.652 1.672-1.776 2.01-.6 1.633.965 3.198 2.598 2.598.338-.124.513-.28 2.01-1.776 1.514-1.514 1.65-1.67 1.782-2.024a2.025 2.025 0 0 0-.99-2.512c-.45-.232-1.142-.263-1.632-.072M30.56 13.16c-8.374.692-15.265 6.714-17.018 14.872-.316 1.47-.384 2.161-.386 3.936-.002 1.736.04 2.225.323 3.69 1.41 7.335 7.196 13.219 14.553 14.8 1.487.32 2.157.385 3.968.385s2.481-.065 3.968-.385a18.8 18.8 0 0 0 11.11-7.106c1.967-2.61 3.15-5.486 3.652-8.888.159-1.078.158-3.837-.001-4.928-.628-4.29-2.425-7.92-5.385-10.88-2.92-2.921-6.497-4.712-10.688-5.352-.812-.124-3.284-.21-4.096-.144m-.256 4.067c-2.678.302-5.552 1.508-7.633 3.201-3.06 2.492-5.03 6.098-5.451 9.985-.087.798-.087 2.376 0 3.174.3 2.771 1.482 5.62 3.209 7.742 2.49 3.059 6.1 5.03 9.985 5.452.797.086 2.375.086 3.172 0 2.869-.312 5.692-1.511 7.934-3.37 1.597-1.325 2.82-2.883 3.788-4.828a14.74 14.74 0 0 0 0-13.166c-.997-2.001-2.27-3.597-3.978-4.987-2.119-1.726-4.976-2.91-7.743-3.21-.73-.08-2.553-.076-3.283.007M3.232 30.1c-.556.218-.968.597-1.194 1.099-.2.445-.2 1.151.002 1.606.167.381.56.785.968.997.285.147.316.15 2.677.167l2.39.019.333-.153c.472-.216.772-.503.997-.954.166-.333.195-.462.194-.876 0-.817-.38-1.434-1.101-1.795l-.39-.195-2.342.005c-1.633.003-2.4.027-2.534.08m52.275.108c-.726.363-1.105.978-1.106 1.797 0 .414.028.543.194.876.225.45.525.738.997.954l.333.153 2.39-.019c2.36-.018 2.392-.02 2.677-.167.726-.377 1.112-1.003 1.112-1.803s-.386-1.426-1.112-1.803c-.285-.147-.316-.15-2.69-.167l-2.4-.018zM14.016 47.37c-.312.118-.538.319-1.992 1.773-1.514 1.514-1.65 1.67-1.782 2.024-.598 1.613.977 3.188 2.59 2.59.355-.131.51-.268 2.024-1.782 1.497-1.497 1.652-1.672 1.776-2.01.602-1.638-.983-3.21-2.616-2.595m34.464.02c-1 .41-1.49 1.544-1.112 2.575.124.338.28.513 1.776 2.01 1.514 1.514 1.67 1.65 2.024 1.782 1.613.598 3.188-.977 2.59-2.59-.131-.355-.268-.51-1.782-2.024-1.497-1.497-1.672-1.652-2.01-1.776a2 2 0 0 0-1.486.024m-17.362 7.204c-.45.225-.738.525-.954.997l-.152.333.018 2.39c.018 2.36.02 2.392.167 2.677.377.726 1.003 1.112 1.803 1.112s1.426-.386 1.803-1.112c.147-.285.15-.316.167-2.677l.019-2.39-.153-.333c-.216-.472-.503-.772-.954-.997-.333-.166-.462-.195-.882-.195s-.549.029-.882.195" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconLightMode.displayName = 'IconLightMode';